import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { Button } from '@/ui_v3';
import { type SchoolFormData } from './SchoolSearchModal';
interface SchoolSearchModalFooterProps {
  isManualMode: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
export const SchoolSearchModalFooter = ({
  isManualMode,
  onCancel,
  onConfirm
}: SchoolSearchModalFooterProps) => {
  const {
    control,
    setValue
  } = useFormContext<SchoolFormData>();
  const schoolName = useWatch({
    control,
    name: 'schoolName'
  });
  const schoolType = useWatch({
    control,
    name: 'schoolType'
  });
  const schoolGrade = useWatch({
    control,
    name: 'schoolGrade'
  });
  const {
    t
  } = useTranslation(['common']);

  // 학년이 없는 학교급 체크
  const noGradeSchoolTypes = ['COLLEGE', 'OTHER', 'KINDERGARTEN'];
  const isNoGrade = noGradeSchoolTypes.includes(schoolType || '');

  // 학년이 없는 학교급이면 schoolGrade 체크를 하지 않음
  const isConfirmDisabled = isManualMode ? !schoolName || !schoolType || !isNoGrade && !schoolGrade : !isNoGrade && !schoolGrade;
  return <div className="flex gap-xs" data-sentry-component="SchoolSearchModalFooter" data-sentry-source-file="SchoolSearchModalFooter.tsx">
      <Button size="lg" intent="neutral" variant="contained" onClick={onCancel} className="flex-1" data-sentry-element="Button" data-sentry-source-file="SchoolSearchModalFooter.tsx">
        {t('global.cancel.button')}
      </Button>
      <Button size="lg" intent="strong" variant="contained" onClick={() => {
      if (isManualMode) {
        setValue('verifiedSchool', {
          standardCode: 'noStandardCode'
        });
      }
      onConfirm();
    }} disabled={isConfirmDisabled} className="flex-1" data-sentry-element="Button" data-sentry-source-file="SchoolSearchModalFooter.tsx">
        {t('global.confirm.button')}
      </Button>
    </div>;
};